const CAT_PREFIX = 'hid'

export const constructCatId = (id) => {
  return `${CAT_PREFIX}${id}`
}
